import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBannersResponse } from '../models/banner.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BannerService {

  private URL: string = environment.rootUrl;

  constructor(
    private http: HttpClient
  ) { }

  public getBanners(platform: string, type: string, store_id?: string): Observable<IBannersResponse> {
    let params = new HttpParams();
    if (store_id) {
      params = params.set('branch', store_id);
    }
    return this.http.get<IBannersResponse>(`${this.URL}/banners?type_platform=${platform}&type=${type}`, { params });
  }
}
